import { resolveCheckoutFulfillment } from "./checkout-delivery";

const legacyScheduleKeys = [
  "deliveryTimeChange",
  "recoveryTimeChange",
  "customDeliveryTime",
  "customRecoveryTime",
] as const;

export const migrateCheckoutStore = (persistedState: Record<string, unknown>) => {
  const migratedState = { ...persistedState };

  for (const key of legacyScheduleKeys) {
    delete migratedState[key];
  }

  if (
    (migratedState.wantsDelivery === "yes" || migratedState.wantsDelivery === "no") &&
    (migratedState.wantsToRecoverItems === "yes" || migratedState.wantsToRecoverItems === "no")
  ) {
    const fulfillment = resolveCheckoutFulfillment(migratedState.wantsDelivery);
    migratedState.wantsToRecoverItems = fulfillment.wantsRecovery;
  }

  return migratedState;
};
